import { render, staticRenderFns } from "./ddoSelectSwitchCustomer.vue?vue&type=template&id=4899dc04&"
import script from "./ddoSelectSwitchCustomer.vue?vue&type=script&lang=js&"
export * from "./ddoSelectSwitchCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VChip,VListItemContent,VListItemSubtitle,VListItemTitle,VSwitch})
